import {
  AppCard,
  PageContainer,
} from "@equinor/e-procurement-portal-and-ts-portal-front-end-components";
import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { ForbiddenError } from "../../../../../errors/ForbiddenError";
import { fetchTermsException } from "../../../../../services/termsExceptions";
import { EditTermsExceptionForm } from "./-internal_components/EditTermsExceptionForm";
import { TermsExceptionAttachments } from "./-internal_components/TermsExceptionAttachments";

const TermsExceptionsEdit: React.FC = () => {
  const { t } = useTranslation();

  const termsException = Route.useLoaderData();

  return (
    <PageContainer
      showBackButton
      subtitle={termsException.vendor.fullvendorname}
      title={t("termsExceptions.edit.title")}
    >
      <AppCard>
        <EditTermsExceptionForm termsException={termsException} />
      </AppCard>

      <TermsExceptionAttachments
        attachments={termsException.file_attachments}
      />
    </PageContainer>
  );
};

export const Route = createFileRoute(
  "/_private/vsupplierregistration/terms_exceptions/$termExceptionId/edit",
)({
  beforeLoad({ context }) {
    if (context.auth.user?.roles_names.includes("Terms Exception - Update")) {
      return;
    }

    throw new ForbiddenError();
  },
  component: TermsExceptionsEdit,
  loader: ({ params: { termExceptionId } }) =>
    fetchTermsException(termExceptionId),
});
